import * as React from 'react';
import { connect } from 'react-redux';

import { ITrackingProps, setFullStoryUserId } from '../../../plugins';
import { IState } from '../../../store/reducer';

const mapStateToProps = (state: IState) => {
	// note this is unaffected by impersonation, which is stored in separate state object
	const userId = state.entities.auth.session.current.ownerId;
	const email = state.entities.auth.session.current.attributes?.email;
	const name = state.data.customers?.byId[userId]?.name;
	const companyName = state.data.customers?.byId[userId]?.company_name;

	return {
		userId,
		email,
		name,
		companyName
	};
};

const TrackingComponent: React.FC<ITrackingProps> = (props) => {
	setFullStoryUserId(props.userId);
	if ((window as any).Rollbar) {
		(window as any).Rollbar.configure({
			payload: {
				person: {
					id: props.userId
				}
			}
		});
	}
	return null;
};

export const Tracking = connect(mapStateToProps)(TrackingComponent);
